import React from "react";

import MagicLink from "components/base/MagicLink";
import Footer from "components/layout/Footer";
import styled from "styled-components";

const Text = styled.p`
  text-align: justify;
`;

export default function FooterWrapper() {
  return (
    <Footer>
      <h2>D'ou viennent ces données ?</h2>
      <Text>
        Cette page web réutilise les données du{" "}
        <MagicLink to="https://www.sevadec.fr/calendrier-fruits-legumes">
          calendrier des fruits et légumes de saison
        </MagicLink>{" "}
        des producteurs sur le territoire du Pays du Calaisis{" "}
        {/*<MagicLink to="https://www.ademe.fr/calendrier-fruits-legumes-saison">
          calendrier des fruits et légumes de saison de l'ADEME 
        </MagicLink>{" "} */}
        et de la base de donnée{" "}
        <MagicLink to="https://agribalyse.ademe.fr/">Agribalyse</MagicLink>.
        Agribalyse est la base de données de référence des indicateurs d'impacts
        environnementaux des produits agricoles produits en France et des
        produits alimentaires consommés en France.
      </Text>
    </Footer>
  );
}
